import axios from 'axios'
import { VueAxios } from './axios'
import notification from 'ant-design-vue/es/notification'
import _ from 'lodash'
import config from '@/config/defaultSettings'
import Url from 'url-parse'

// 创建 axios 实例
const service = axios.create({
  baseURL: '', // api base_url
  timeout: 300000, // 请求超时时间
  headers: config.production ? {} : { 'debug': 1 }
})

const err = (error) => {
  if (error.response) {
    const data = error.response.data
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    }
    if (error.response.status === 401) {
      notification.error({
        message: 'Unauthorized',
        description: 'Authorization verification failed'
      })
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  // allowList
  // disalble notification
  const allowList = [
    '/v3/geocode/regeo',
    '/v3/assistant/inputtips'
  ]
  const code = _.get(response, 'data.code')
  const URL = new Url(response.request.responseURL)

  if (allowList.indexOf(URL.pathname) !== -1) {
    return response
  }
  switch (code) {
    // 用户未登陆
    case 7202:
      notification.error({
        message: '错误',
        description: `${response.data.message}`,
        duration: 2.5,
        onClose: () => {
          if (URL.pathname !== '/admin.php/User/login') {
            window.location.href = '/user/login'
          }
        }
      })
      return response.data

    case 200:
      return response.data

    default:
      notification.error({
        message: '错误',
        description: `${response.data.message}`
      })
      return response.data
  }
}, err)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
